<template>
  <div>
    <server-error :error="error" />
    <div v-if="isLoaded">
      <div v-if="reportTableData !== null">
        <div class="b-reports__table-wrapper b-reports__table-wrapper_type_short px-6">
          <div class="b-full-table b-reports__table-wrap mt-4">
            <div class="b-reports__table-header-wrap">
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell b-reports__table-cell_type_medium">
                {{$t('CONTENT.reportPage.value_name')}}
              </div>
              <div class="b-reports__table-header-block-wrap">
                <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-block-title">
                  {{$t('CONTENT.reportPage.maturity')}}
                </div>
                <div class="b-reports__table-header-block-inner">
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell" v-for="details in reportTableData.details">
                   {{details.period.label}}
                  </div>
                </div>
              </div>
            </div>
            <div class="b-reports__table-row">
              <div class="b-full-table__cell b-reports__table-cell b-reports__table-cell_type_medium">
                {{$t('CONTENT.reportPage.un_discounted_lease_obligation')}}
              </div>
              <div class="b-reports__table-block-wrap">
                <div class="b-full-table__cell b-reports__table-cell" v-for="details in reportTableData.details">
                  <div class="b-full-table__arrow"
                       :class="{'b-full-table__arrow_type_open' : currentItem !== null && currentItem.label === details.period.label}"
                       @click="showCurrentDetails(details)"></div>
                  {{convertDecimalToStringForChart(details.totalSum)}}
                </div>
              </div>
            </div>
            <div>
              <transition name="fade">
                <div class="b-reports__table-inner-table p-4" v-if="currentItem !== null">
                  <h4>{{$t('CONTENT.reportPage.details')}}</h4>
                  <div class="mt-1">{{$t('CONTENT.reportPage.maturity')}} - {{currentItem.period.label}}</div>
                  <div class="b-reports__table-wrapper b-reports__table-wrapper_type_short mt-4">
                    <div class="b-full-table b-reports__table-wrap">
                      <div class="b-reports__table-header-wrap">
                        <div
                          class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                          {{$t('CONTENT.reportPage.contract_code')}}
                        </div>
                        <div
                          class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                          {{$t('CONTENT.reportPage.contract_external_id')}}
                        </div>
                        <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                          {{$t('CONTENT.reportPage.scheduled_accruals_for_the_period')}}
                        </div>
                      </div>
                      <div class="b-reports__table-row" v-for="detailsItem in currentItem.contracts">
                        <div class="b-full-table__cell b-reports__table-cell">
                          {{detailsItem.code}}
                        </div>
                        <div class="b-full-table__cell b-reports__table-cell">
                          {{detailsItem.contractExternalId}}
                        </div>
                        <div class="b-full-table__cell b-reports__table-cell">
                          {{convertDecimalToStringForChart(detailsItem.sum)}}
                        </div>
                      </div>
                      <div class="b-reports__table-row b-reports__table-row-total">
                        <div class="b-full-table__cell b-reports__table-cell">
                          {{$t('CONTENT.reportPage.total')}}
                        </div>
                        <div class="b-full-table__cell b-reports__table-cell">
                          {{convertDecimalToStringForChart(currentItem.totalSum)}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReportsAPI from "../api/ReportsAPI";
import convertDecimalForChart from "@/utils/converters/convert.decimal.for.chart";

export default {
  props: {
    dataForReport: {
      type: Object,
    },
  },
  data() {
    return {
      error: null,
      currentItem: null,
      reportTableData: null,
    };
  },
  async created() {
    await this.formReport(this.dataForReport);
  },
  watch: {
    dataForReport: {
      handler(newVal) {
        this.formReport(newVal);
      },
      deep: true
    },
  },
  methods: {
    async formReport(data) {
      try {
        this.$loadingManager.addLoadingStep();
        this.error = null;
        this.reportTableData = null;
        this.reportTableData = await new ReportsAPI().getSummaryReportBasedOnLiabilitiesMaturity({
          periodStart: data.periodStart,
          lesseeId: data.lesseeId
        });
        this.$parent.nonActiveContractIds = this.reportTableData.nonActiveContractIds;
        this.$loadingManager.loadingStepLoaded();
      } catch (e) {
        this.$loadingManager.hideLoadScreen();
        this.error = e;
      }
    },
    convertDecimalToStringForChart(decimal) {
      return convertDecimalForChart(decimal);
    },

    async exportReportData() {
      this.error = null;
      try {
        const api = new ReportsAPI();
        const response = await api.exportResultOfSummaryReportBasedOnLiabilitiesMaturity(this.reportTableData);

        let filename = null;
        let filenameInURI = null;

        let headerContentDisposition = response.headers['content-disposition'].split(';');
        for (let i = 0; i < headerContentDisposition.length; i++) {
          let item = headerContentDisposition[i].split('=');
          if(item[0].trim() === 'filename*') {
            filenameInURI = item[1].split("''");
            filename = decodeURIComponent(filenameInURI[1]);
          }
        }

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");

        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
      } catch (e) {
        this.error = e;
        console.error(e);
      }
    },
     showCurrentDetails(currentItem) {
      if(this.currentItem !== null && this.currentItem.name === currentItem.period.name) {
        this.currentItem = null;
      } else {
        this.currentItem = null;
        this.currentItem = currentItem;
      }
     },
    getReportPeriodName(periodName) {
      return periodName;
      let currentPeriodName = `${this.$t('CONTENT.reportPage.' + periodName)}`;
      let [firstLetter, ...tail] = currentPeriodName;
      return firstLetter.toLowerCase() + tail.join('');
    },
  }
};
</script>
